import routes from "@/routes/routes";

import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// Compatibilidade com links antigos:
const hash = window.location.hash;

if (
  window.location.pathname === '/' &&
  hash.startsWith('/')
) {
  const path = hash.substring(1);

  window.history.replaceState(
    null,
    '',
    path
  );
}

const router = new VueRouter({
  mode: "history",

  routes,

  linkActiveClass: "nav-item active",

  scrollBehavior: function (to) {
    if (to.hash) return { selector: to.hash };

    return { x: 0, y: 0 };
  }
});

export default router;